import { render, staticRenderFns } from "./PI4.vue?vue&type=template&id=3903c014&scoped=true&"
import script from "./PI4.vue?vue&type=script&lang=js&"
export * from "./PI4.vue?vue&type=script&lang=js&"
import style0 from "./PI4.vue?vue&type=style&index=0&id=3903c014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3903c014",
  null
  
)

export default component.exports